import { AuthenticationApi, MFAApi } from './lib/api.js';
import { Configuration } from './lib/configuration.js';
const runtimeGlobal = globalThis;
function sanitizeBase(input) {
    const trimmed = input?.trim();
    if (!trimmed)
        return undefined;
    if (trimmed === '/')
        return '';
    return trimmed.replace(/\/$/, '');
}
export function resolveConfiguredBase(runtime) {
    const configuredBase = runtime.process?.env?.VITE_IDP_BASE_URL ?? runtime.importMetaEnv?.VITE_IDP_BASE_URL;
    return sanitizeBase(configuredBase) ?? '';
}
const initialBasePath = resolveConfiguredBase(runtimeGlobal);
function createConfiguration(basePath) {
    return new Configuration({ basePath, baseOptions: { headers: {} } });
}
const config = createConfiguration(initialBasePath);
export let authApi = new AuthenticationApi(config);
export let mfaApi = new MFAApi(config);
let tokenDeliveryMode = 'json';
export function getIdpTransport() {
    const api = authApi;
    return { base: sanitizeBase(api.basePath) ?? '', axiosInst: api.axios };
}
export function buildIdpUrl(base, path) {
    return base ? `${base}${path}` : path;
}
export const verifyEmail = (params) => {
    const { base, axiosInst } = getIdpTransport();
    return axiosInst.post(buildIdpUrl(base, '/api/auth/verify-email'), params);
};
export function bindIdpClient(client) {
    authApi = client.authApi;
    mfaApi = client.mfaApi;
    tokenDeliveryMode = client.tokenDelivery;
}
export function setIdpBaseUrl(basePath) {
    const nextConfig = createConfiguration(sanitizeBase(basePath) ?? initialBasePath);
    authApi = new AuthenticationApi(nextConfig);
    mfaApi = new MFAApi(nextConfig);
    tokenDeliveryMode = 'json';
}
function normalizeTokenDelivery(value) {
    if (typeof value !== 'string')
        return undefined;
    const normalized = value.trim().toLowerCase();
    return normalized === 'cookie' || normalized === 'json' ? normalized : undefined;
}
export function getTokenDeliveryMode() {
    const meta = runtimeGlobal.document?.querySelector('meta[name="idp-token-delivery"]');
    const metaMode = normalizeTokenDelivery(meta?.getAttribute('content'));
    const appMode = normalizeTokenDelivery(runtimeGlobal.APP_CONFIG?.idpTokenDelivery);
    return metaMode ?? appMode ?? tokenDeliveryMode;
}
//# sourceMappingURL=runtime-client.js.map